var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { bindAllTo } from './';
/**
 * Return an object with context-bound versions of everything on the source object's
 * prototype.
 *
 * @param {any} An instance of something
 * @param {object} filter An optional filter. This can be an array of strings to
 *    match the property name, or a callback function which will be invoked with the method name
 * @returns {object} A new object with bound versions of each proto method
 */
export default function getBound(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return bindAllTo.apply(void 0, __spreadArrays([{}, obj], args));
}
//# sourceMappingURL=get-bound.js.map